module.exports = __webpack_public_path__ + "c610a4087f30eeb844e36263a333811b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarity_diamond_ring@2x.png
// module id = 818
// module chunks = 0